// Version : 0.0.1
// Author : AGALYA

const GoldLoanProposalActionTypes = {
	/** ***************** ADD GOLD LOAN PROPOSAL START ***************** */
	ADD_GOLD_LOAN_PROPOSAL_START: 'ADD_GOLD_LOAN_PROPOSAL_START',
	ADD_GOLD_LOAN_PROPOSAL_SUCCESS: 'ADD_GOLD_LOAN_PROPOSAL_SUCCESS',
	ADD_GOLD_LOAN_PROPOSAL_FAILURE: 'ADD_GOLD_LOAN_PROPOSAL_FAILURE',
	ADD_GOLD_LOAN_PROPOSAL_RESPONSE_RESET: 'ADD_GOLD_LOAN_PROPOSAL_RESPONSE_RESET',
	ADD_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED: 'ADD_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/** ***************** ADD GOLD LOAN PROPOSAL END ***************** */

	/** ***************** UPDATE GOLD LOAN PROPOSAL START ***************** */
	UPDATE_LOAN_PROPOSAL_START: 'UPDATE_LOAN_PROPOSAL_START',
	UPDATE_LOAN_PROPOSAL_SUCCESS: 'UPDATE_LOAN_PROPOSAL_SUCCESS',
	UPDATE_LOAN_PROPOSAL_FAILURE: 'UPDATE_LOAN_PROPOSAL_FAILURE',
	UPDATE_LOAN_PROPOSAL_RESPONSE_RESET: 'UPDATE_LOAN_PROPOSAL_RESPONSE_RESET',
	UPDATE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'UPDATE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/** ***************** UPDATE GOLD LOAN PROPOSAL END ***************** */

	/** ***************** DELETE GOLD LOAN PROPOSAL START ***************** */
	DELETE_LOAN_PROPOSAL_START: 'DELETE_LOAN_PROPOSAL_START',
	DELETE_LOAN_PROPOSAL_SUCCESS: 'DELETE_LOAN_PROPOSAL_SUCCESS',
	DELETE_LOAN_PROPOSAL_FAILURE: 'DELETE_LOAN_PROPOSAL_FAILURE',
	DELETE_LOAN_PROPOSAL_RESPONSE_RESET: 'DELETE_LOAN_PROPOSAL_RESPONSE_RESET',
	DELETE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'DELETE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/** ***************** DELETE GOLD LOAN PROPOSAL END ***************** */

	/** ***************** FETCH GOLD LOAN PROPOSAL START ***************** */
	FETCH_GOLD_LOAN_PROPOSAL_START: 'FETCH_GOLD_LOAN_PROPOSAL_START',
	FETCH_GOLD_LOAN_PROPOSAL_SUCCESS: 'FETCH_GOLD_LOAN_PROPOSAL_SUCCESS',
	FETCH_GOLD_LOAN_PROPOSAL_FAILURE: 'FETCH_GOLD_LOAN_PROPOSAL_FAILURE',
	FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_RESET: 'FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_RESET',
	FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED: 'FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/** ***************** FETCH GOLD LOAN PROPOSAL END ***************** */

	/** ***************** GET GOLD LOAN PROPOSAL START ***************** */
	GET_GOLD_LOAN_PROPOSAL_START: 'GET_GOLD_LOAN_PROPOSAL_START',
	GET_GOLD_LOAN_PROPOSAL_SUCCESS: 'GET_GOLD_LOAN_PROPOSAL_SUCCESS',
	GET_GOLD_LOAN_PROPOSAL_FAILURE: 'GET_GOLD_LOAN_PROPOSAL_FAILURE',
	GET_GOLD_LOAN_PROPOSAL_RESPONSE_RESET: 'GET_GOLD_LOAN_PROPOSAL_RESPONSE_RESET',
	GET_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED: 'GET_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/** ***************** GET GOLD LOAN PROPOSAL END ***************** */

	/** ***************** APPROVE GOLD LOAN PROPOSAL START ***************** */
	APPROVE_LOAN_PROPOSAL_START: 'APPROVE_LOAN_PROPOSAL_START',
	APPROVE_LOAN_PROPOSAL_SUCCESS: 'APPROVE_LOAN_PROPOSAL_SUCCESS',
	APPROVE_LOAN_PROPOSAL_FAILURE: 'APPROVE_LOAN_PROPOSAL_FAILURE',
	APPROVE_LOAN_PROPOSAL_RESPONSE_RESET: 'APPROVE_LOAN_PROPOSAL_RESPONSE_RESET',
	APPROVE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'APPROVE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/** ***************** APPROVE GOLD LOAN PROPOSAL END ***************** */

	/** ***************** REVERT GOLD LOAN PROPOSAL START ***************** */
	REVERT_LOAN_PROPOSAL_START: 'REVERT_LOAN_PROPOSAL_START',
	REVERT_LOAN_PROPOSAL_SUCCESS: 'REVERT_LOAN_PROPOSAL_SUCCESS',
	REVERT_LOAN_PROPOSAL_FAILURE: 'REVERT_LOAN_PROPOSAL_FAILURE',
	REVERT_LOAN_PROPOSAL_RESPONSE_RESET: 'REVERT_LOAN_PROPOSAL_RESPONSE_RESET',
	REVERT_LOAN_PROPOSAL_RESPONSE_CHANGED: 'REVERT_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/** ***************** REVERT GOLD LOAN PROPOSAL END ***************** */

	/** ***************** GET SEARCH GOLD LOAN MEMBER START ***************** */
	GET_SEARCH_GOLD_LOAN_MEMBER_START: 'GET_SEARCH_GOLD_LOAN_MEMBER_START',
	GET_SEARCH_GOLD_LOAN_MEMBER_SUCCESS: 'GET_SEARCH_GOLD_LOAN_MEMBER_SUCCESS',
	GET_SEARCH_GOLD_LOAN_MEMBER_FAILURE: 'GET_SEARCH_GOLD_LOAN_MEMBER_FAILURE',
	GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_RESET: 'GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_RESET',
	GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_CHANGED: 'GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_CHANGED',
	/** ***************** GET SEARCH GOLD LOAN MEMBER END ***************** */
};

export default GoldLoanProposalActionTypes;
